import Vue from 'vue'
import App from './App.vue'
import VideoList from './components/VideoList';
import Settings from './components/Settings';

const gtag = window.gtag;

window.onerror = function(message, source, lineno, colno, error) {
  gtag('event', 'exception', {
    description: `uncaught excaption: ${message}, source: ${source}, lineno: ${lineno}, colno: ${colno}, error: ${error.message}`,
    fatal: true,
  });
};

(async () => {
  const [
    { default: VueRouter },
    { vuex, createStore },
    { default: i18next },
    { default: XHR },
    { default: LngDetector },
    { default: VueI18Next },
    { default: firebase },
  ] = await Promise.all([
    import(/* webpackChunkName: "vue-i18next" */'vue-router'),
    import(/* webpackChunkName: "vue-i18next" */'../../vuex/store'),
    import(/* webpackChunkName: "vue-i18next" */'i18next'),
    import(/* webpackChunkName: "vue-i18next" */'i18next-xhr-backend'),
    import(/* webpackChunkName: "vue-i18next" */'i18next-browser-languagedetector'),
    import(/* webpackChunkName: "vue-i18next" */'@panter/vue-i18next'),
    import(/* webpackChunkName: "firebase-chunk1" */'firebase/app'),
    import(/* webpackChunkName: "firebase-chunk1" */'firebase/database'),
    import(/* webpackChunkName: "firebase-chunk2" */'firebase/firestore'),
    import(/* webpackChunkName: "firebase-chunk3" */'firebase/auth'),
  ])

  Vue.use(vuex);
  Vue.use(VueRouter);
  
  Vue.config.productionTip = false

  firebase.initializeApp(require('../firebase-config.json'));
  const { projectId } = firebase.app().options;
  Vue.use(VueI18Next);
  i18next
    .use(LngDetector)
    .use(XHR)
    .init({
      fallbackLng: 'en',
    });
  const i18n = new VueI18Next(i18next);
  const urlParams = new URLSearchParams(window.location.search);
  const firebaseCustomToken = urlParams.get('fct');
  const videoSource = urlParams.get('source');
  const regionCode = urlParams.get('regionCode');
  const eventId = urlParams.get('eventId');
  const access_token = urlParams.get('access_token');
  let error, uid;
  if (access_token) {
    try {
      const result = await firebase.auth().signInWithCustomToken(firebaseCustomToken);
      uid = result.user.uid;
    } catch (err) {
      error = err;
      // eslint-disable-next-line no-console
      console.error('signInWithCustomToken failed', err, err.toString());
      gtag('event', 'exception', {
        description: `sign_in_with_custom_token_failed. ${err.toString && err.toString()}`,
        fatal: false,
      });
    }  
  }

  if (urlParams.has('error')) {
    error = Error(urlParams.get('msg'));
  }

  const store = createStore({
    database: firebase.database(),
    uid,
    videoSource,
    regionCode,
    googleApiKey: process.env.VUE_APP_GOOGLE_API_KEY,
    exception: error,
    maxResults: 24,
    firestore: firebase.firestore(),
    eventId,
    isLoggedInUser: access_token != undefined && access_token.length > 0,
    access_token,
    projectId,
  });
  const router = new VueRouter({
    routes: [
      {
        path: '*',
        redirect: `/video/${videoSource}`,
      },
      {
        name: 'videoList',
        path: '/video/:video_source',
        component: VideoList,
      },
      {
        name: 'settings',
        path: '/settings',
        component: Settings,
      },
    ],
  });
  router.afterEach((to) => {
    if (to.name == 'videoList') {
      if (error) {
        return;
      }
      const videoSource = to.params.video_source;
      // eslint-disable-next-line no-console
      console.log(`changeVideoSource to: ${videoSource}`);
      store.dispatch('changeVideoSource', videoSource);
    }
  });
  new Vue({
    store,
    i18n,
    router,
    render: h => h(App),
  }).$mount('#app');
    
})();
